export enum Role {
  Issuer = 'issuer',
  Approver = 'approver',
  Admin = 'admin',
  Candidate = 'candidate',
  None = 'none',
}
